"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const SvgLogoDevolutions = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M19.889,4.342c-2.056,-2.117 -4.808,-3.304 -7.749,-3.341c-2.93,-0.037 -5.698,1.087 -7.802,3.165c-2.152,2.126 -3.338,4.964 -3.338,7.994l0.018,0.513c0,0.481 0.391,0.873 0.873,0.873c0.481,0 0.872,-0.391 0.873,-0.872l0.004,-0.372c0,-4.052 3.444,-8.39 8.57,-8.39c5.35,0 8.662,4.364 8.662,8.408c0,2.108 -0.84,4.041 -2.366,5.444c-1.489,1.37 -3.49,2.124 -5.633,2.124c-1.275,0 -2.534,-0.308 -3.65,-0.891l7.688,-3.539c0.516,-0.238 0.862,-0.737 0.902,-1.304c0.04,-0.567 -0.232,-1.11 -0.715,-1.421l-6.399,-3.428c-0.226,-0.146 -0.495,-0.195 -0.757,-0.138c-0.263,0.057 -0.487,0.213 -0.633,0.438c-0.3,0.466 -0.165,1.089 0.294,1.384l3.444,2.821l-7.504,3.454c-0.581,0.268 -0.936,0.855 -0.904,1.497c0.02,0.387 0.201,0.768 0.511,1.073c2.083,2.053 4.805,3.166 7.716,3.166c0.181,0 0.363,-0.004 0.546,-0.013c5.767,-0.274 10.361,-5.017 10.458,-10.798c0.05,-2.945 -1.054,-5.731 -3.109,-7.847Z" })));
exports.default = SvgLogoDevolutions;
